import { render, staticRenderFns } from "./ConfiguracoesMensageria.vue?vue&type=template&id=53cf711a"
import script from "./ConfiguracoesMensageria.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMensageria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cf711a')) {
      api.createRecord('53cf711a', component.options)
    } else {
      api.reload('53cf711a', component.options)
    }
    module.hot.accept("./ConfiguracoesMensageria.vue?vue&type=template&id=53cf711a", function () {
      api.rerender('53cf711a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConfiguracoesMensageria.vue"
export default component.exports